export default __webpack_public_path__ + "static/media/2_0120.8b5abb71.webp";